import {InvoiceAndReceiptsService} from '@common/services/invoices-and-receipts.service';
import {CancelActivitiesModule} from './_app_modules/mojo/cancel-activities/cancel-activities.module';
import {
  CashBalanceGroupTypeProvider,
  CashBalanceHttpService,
  CashBalancesWidgetAdminHandler
} from "@feature/cash-balances";
import {PmaEntityKeyHttpService} from "@pma-entity/services/pma-entity-key-http.service";
import {MojoDashboardProductService} from "@feature/product/services/mojo-dashboard-product.service";
import {PaymentsToYouWidgetAdminHandler} from "@feature/payments-to-you/services/payments-to-you-widget-admin-handler";
import {DefaultAdminHandler} from "@feature/details";
import {
  MfsSupplierDetailsHttpService,
  SupplierDetailsEffects,
  SupplierDetailsService,
  SupplierOtherCreditorEffects,
  SupplierOtherCreditorHttpService
} from "@feature/suppliers";
import {ClientParentDetailsMapperService, ClientParentEffects, ClientParentService} from "@feature/client-parents";
import {ContextToHttpParamsService, RouteContextService} from "@feature/context";
import {ProfileHttpService} from "@profiles/services/profile-http.service";
import {
  DashboardItemProviderService,
  GridsterConfigProviderService,
  MasterAdminDashboardItemProviderService
} from "@feature/dashboards";
import {PmaPermissionsGuardService, RoleGuardService, RoleHttpService} from "@feature/roles";
import {TokenService} from "@feature/auth";
import {PropertyPictureService, PropertyPictureWidgetAdminHandler} from "@feature/properties";
import {TenancyScheduleTableColumnsEffects} from "@tenancy-schedule/effects/tenancy-schedule-table-columns";
import {ArrearsWidgetModule} from "@arrears-widget/arrears-widget.module";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {CurrencyPipe, DatePipe, DecimalPipe} from "@angular/common";
import {BrowserModule} from "@angular/platform-browser";
import {
  MojoDashboardMciCommonModule,
} from "@feature/_app_modules/mojo-dashboard-mci-common/mojo-dashboard-mci-common.module";
import {ErrorHandler, NgModule} from "@angular/core";
import {GridsterModule} from "angular-gridster2";
import {ToastrModule} from "ngx-toastr";
import {
  DashboardHelperService,
  DashboardModeOnlyGuard,
  DataFormatter,
  DesktopOnlyDirective,
  DeviceDetectorModule,
  GlobalErrorHandler,
  HttpErrorInterceptor,
  IdServerInterceptor,
  MathematicalHelperService
} from "@feature/common";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {UserPermissionsService} from "@permissions/user-permissions";
import {CurrentProductService} from "@product/services/current-product.service";
import {ProductRouteNavigator} from "@product/services/product-route-navigator";
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {environment} from "@environments/environment";
import {
  DebtBalancesDueFacadeService
} from '@feature/_app_modules/debt-balances-due-widget/services/debt-balances-due-widget-facade.service';
import {AngularSvgIconModule} from "angular-svg-icon";
/** should be common module */
import {
  AuthorisedBlobService,
  ColumnFormatterService,
  CountToModule,
  CsvDataService,
  DashboardHomePageRouteGuard,
  ExternalUrlRouteGuard,
  FileHelperService,
  FilterEffects,
  FilterService,
  GlobalStartupService,
  HideDropdownOnScrollModule,
  HomepageManagerService,
  HomepageSelectionHttpService,
  MapListPipe,
  MfsLimitedAccessConfigService,
  NumericInputDirectiveModule,
  PasswordValidationService,
  PasswordValidator,
  RequestStoreService,
  UrlBuilderService,
} from "@common/index";
/** end of common module */
import {AppComponent} from "./app.component";
import {OutstandingDebtService} from "@outstanding-debts/services/outstanding-debt.service";
import {StoreModule} from "@ngrx/store";
import {StoreDevtoolsModule} from "@ngrx/store-devtools";
import {getReducers, metaReducers} from "@store/application-store";
import {EffectsModule} from "@ngrx/effects";
import {OutstandingDebtEffects} from "@outstanding-debts/effects/outstanding-debt";
import {GlobalNotFoundComponent} from "@containers/global-not-found/global-not-found.component";
import {
  OutstandingDebtChartWrapperComponent
} from "@outstanding-debts/containers/outstanding-debt-chart-wrapper/outstanding-debt-chart-wrapper.component";
import {
  OutstandingDebtChartComponent
} from "@outstanding-debts/components/outstanding-debt-chart/outstanding-debt-chart.component";
import {BrandProvider, BrandService} from "./brand/index";
import {
  DocumentCentreConfigHttpService,
  EmailTemplateEffects,
  EmailTemplateHttpService,
  EmailTemplateService,
  ListerConfigurationHttpService,
  ListerConfigurationService,
  SystemConfigurationHttpService,
  SystemConfigurationService
} from "@admin/index";
import {NgMathPipesModule} from "ngx-pipes";
import {LeaseDetailsMapper} from "@feature/leases";
import {ClientDetailsMapper} from "@feature/clients";
import {CurrencyService} from "@feature/currency";
import {DefaultWidgetAdminHandlerProvider} from "@feature/widget-admin";
import {SharedModule} from "@shared/shared.module";
import {InvalidPlatformComponent} from "@invalid-platform/invalid-platform.component";
import {NotLicensedComponent} from "@not-licensed/components/not-licensed.component";
import {AppRoutingModule} from "./app-routing.module";
import {ActionDispatcher, DispatcherService} from "@store/dispatcher.service";
import {EntityKeyService} from "@pma-entity/services/entity-key.service";
import {ServiceWorkerModule} from '@angular/service-worker';
import {ManagerDetailsEffects, ManagerDetailsHttpService, ManagerDetailsService,} from "./manager-details";
import {ConfirmationService} from "primeng/api";
import {ApplicationModeService} from "./application-mode";
import {UnitDetailsEffects, UnitDetailsMapper, UnitDetailsService,} from "./units";
import {EstateDetailsEffects, EstateDetailsMapper, EstateDetailsService,} from "./estates";
import {LeaseDetailsEffects, LeaseDetailsHttpService} from "./leases";
import {SoftLabelsEffects, SoftLabelsHttpService} from "./soft-labels";
import {
  AdminOverviewTileService,
  EntityRouteGuard,
  OverviewEffects,
  OverviewHttpService,
  OverviewService,
  OverviewUrlService,
} from "./overview";
import {
  PropertyDetailsEffects,
  PropertyDetailsHttpService,
  PropertyDetailsMapper,
  PropertyPictureEffects,
} from "./properties";
import {ClientDetailsEffects, ClientDetailsHttpService} from "./clients";
import {UserSettingsEffects, UserSettingsHttpService, UserSettingsService,} from "./user-settings";
import {DiaryEffects, DiaryEventsHttpService} from "./diary";
import {
  AuthEffects,
  AuthGuardService,
  AuthService,
  OidcAuthRouteGuardService,
  OidcAuthService,
  ProductLicenseGuard,
  TokenInterceptor,
  VersionService,
} from "./auth";
import {UserEffects, UserService} from "./users";
import {AboutEffects, AboutHttpService, AboutService} from "./about";
import {TenancyScheduleTableEffects} from "@tenancy-schedule/effects/tenancy-schedule-table";
import {ContactUsEffects, ContactUsHttpService} from "./contactus";
import {
  DashboardEffects,
  DashboardItemMapper,
  DashboardScrollService,
  DashboardService,
  UserDashboardHttpService,
} from "./dashboards";
import {CashBalanceEffects, CashBalanceLabelService} from "./cash-balances";
import {WidgetConfigurationEffects, WidgetConfigurationsService,} from "./widget-configs";
import {ProfileEffects} from "@profiles/effects/profiles";
import {DashboardDesignerEffects, DefaultDashboardLayoutService,} from "./dashboard-designer";
import {ClientParentDetailsEffects, ClientParentDetailsService,} from "./client-parents";
import {
  TenantDetailsEffects,
  TenantDetailsHttpService,
  TenantDetailsMapperService,
  TenantDetailsService,
} from "./tenants";
import {
  DebtorDetailsEffects,
  DebtorDetailsHttpService,
  DebtorDetailsMapperService,
  DebtorDetailsService,
} from "./debtors";
import {
  LandlordDetailsEffects,
  LandlordDetailsHttpService,
  LandlordDetailsMapperService,
  LandlordDetailsService,
  LandlordTableColumnService,
  LandlordTableColumnsHttpService,
  LandlordTableHttpService,
  LandlordTableService,
} from "./landlords";
import {InvoiceDocumentService, InvoiceUploadEffects, InvoiceUploadHttpService,} from "./invoice-upload";
import {
  PaymentsTableColumnsEffects,
  PaymentsTableEffects,
  PaymentsToYouHttpService,
  PaymentsToYouService,
  PaymentsToYouToastService,
} from "./payments-to-you";
import {DashboardWidgetConfigEffects, DashboardWidgetFilterService,} from "./dashboard-widget";
import {HeadleaseDetailsEffects, HeadLeaseDetailsMapper, HeadleaseDetailsService,} from "./headleases";
import {DashboardModeRoleGuardService, PmaPermissionsService, RoleService,} from "./roles";
import {TenancyScheduleTableHttpService} from "@tenancy-schedule/services/tenancy-schedule-table-http.service";
import {
  TenancyScheduleTableColumnsHttpService
} from "@tenancy-schedule/services/tenancy-schedule-table-columns-http.service";
import {ProfileService} from "@profiles/services/profile.service";
import {PreviewModeService} from "./preview-mode";
import {MojoSystemSettingsService, MojoUrlProvider} from "./mojo";
import {MyActivitiesDataHttpService, MyActivitiesTableHttpService,} from "./my-activities";
import {WidgetGalleryService} from "./widget-gallery";
import {UserProfilesHttpService, UserProfilesService} from "./user-profiles";
import {MfsSupplierDetailsService, SupplierDetailsHttpService,} from "./suppliers";
import {CreditorDetailsWidgetAdminHandler} from "./creditor-details/services/creditor-details-widget-admin-handler";
import {CreditorDetailsService} from "./creditor-details/services/creditor-details.service";
import {CreditorAccountService, CreditorAccountsHttpService,} from "./creditor-accounts";
import {PRODUCT_SERVICE_KEYS} from "@product/services/product-specific.service";
import {MciProductService} from "@product/services/mci-product.service";
import {MfsProductService} from "@product/services/mfs-product.service";
import {MftProductService} from "@product/services/mft-product.service";
import {ProductSpecificServiceProvider} from "@product/services/product-specific-service-provider.service";
import {PmaEntityLookupHttpService} from "@pma-entity/services/pma-entity-lookup-http.service";
import {TenantParentHttpService, TenantParentService} from "./tenant-parent";
import {FuseModule} from '@fuse';
import {FuseConfigModule} from '@fuse/services/config';
import {FuseMockApiModule} from '@fuse/lib/mock-api';
import {appConfig} from 'app/core/config/app.config';
import {mockApiServices} from 'app/mock-api';
import {CoreModule} from './core/core.module';
import {LayoutModule} from './layout/layout.module';
import {CardModuleModule} from './_app_modules/card-layout/card-layout-module.module';
import {UserPreferencesEffects} from './user-preferences/effects/user-preferences';
import {ListTypeUserDataFilterService} from '@common/filter/services/list-type-user-data-filter.service';
import { RouteReuseStrategy } from '@angular/router';
import {MojoRouteReuseStrategy} from "@routing/mojo-route-reuse-strategy";
import {AddOnGuard} from "@auth/services/add-on-guard.service";
import {CreditorDetailsModule} from "@feature/creditor-details/creditor-details.module";
import {
  InvoiceStatusWidgetLineItemDataService
} from "@feature/invoice-status/services/invoice-status-widget-line-item-data.service";
import {MfsInvalidEntityRouteGuard} from "@mfs/default-dashboard/mfs-invalid-entity-route.guard";
import {MfsAllowListHttpDataService} from "@mfs/default-dashboard/services/mfs-allow-list-http-data.service";
import {MfsAllowListDataService} from "@mfs/default-dashboard/services/mfs-allow-list-data.service";
import {MftAllowListHttpDataService} from "@mft/default-dashboard/services/mft-allow-list-http-data.service";
import {MftAllowListDataService} from "@mft/default-dashboard/services/mft-allow-list-data.service";
import {MftInvalidEntityRouteGuard} from "@mft/default-dashboard/mft-invalid-entity-route.guard";
import {InvalidEntityComponent} from "@feature/invalid-entity/components/invalid-entity.component";

export const commonServices = [
  GlobalStartupService,
  PasswordValidationService,
  AuthorisedBlobService,
  UrlBuilderService,
  ColumnFormatterService,
  RequestStoreService,
  HomepageSelectionHttpService,
  HomepageManagerService,
  FileHelperService,
  FilterService,
  MfsLimitedAccessConfigService,
  CsvDataService,
];

@NgModule({
  declarations: [
    AppComponent,
    GlobalNotFoundComponent,
    InvalidPlatformComponent,
    OutstandingDebtChartWrapperComponent, /* @todo: is obsolete? */
    OutstandingDebtChartComponent, /* @todo: is obsolete? */
    PasswordValidator,
    DesktopOnlyDirective,
    NotLicensedComponent,
    InvalidEntityComponent
  ],
  bootstrap: [
    AppComponent
  ],
  imports: [
    CancelActivitiesModule,
    HideDropdownOnScrollModule,
    NumericInputDirectiveModule,
    CountToModule,
    // Fuse, FuseConfig & FuseMockAPI
    FuseModule,
    FuseConfigModule.forRoot(appConfig),
    FuseMockApiModule.forRoot(mockApiServices),
    // Core module of your application
    CoreModule,
    // Layout module of your application
    LayoutModule,
    ArrearsWidgetModule,
    LoggerModule.forRoot({
      level: environment.production
        ? NgxLoggerLevel.ERROR
        : NgxLoggerLevel.DEBUG,
    }),
    SharedModule,
    MojoDashboardMciCommonModule,
    DeviceDetectorModule.forRoot(),
    NgMathPipesModule,
    BrowserModule,
    BrowserAnimationsModule,
    GridsterModule,
    AngularSvgIconModule,
    ToastrModule.forRoot(),
    DragDropModule,
    StoreModule.forRoot(getReducers(), {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
      },
    }),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([
      OutstandingDebtEffects,
      ClientParentEffects,
      ManagerDetailsEffects,
      UnitDetailsEffects,
      EstateDetailsEffects,
      LeaseDetailsEffects,
      SoftLabelsEffects,
      OverviewEffects,
      PropertyDetailsEffects,
      PropertyPictureEffects,
      ClientDetailsEffects,
      UserSettingsEffects,
      DiaryEffects,
      AuthEffects,
      UserEffects,
      AboutEffects,
      TenancyScheduleTableEffects,
      TenancyScheduleTableColumnsEffects,
      ContactUsEffects,
      DashboardEffects,
      CashBalanceEffects,
      WidgetConfigurationEffects,
      ProfileEffects,
      DashboardDesignerEffects,
      FilterEffects,
      ClientParentDetailsEffects,
      TenantDetailsEffects,
      DebtorDetailsEffects,
      LandlordDetailsEffects,
      SupplierDetailsEffects,
      SupplierOtherCreditorEffects,
      InvoiceUploadEffects,
      PaymentsTableEffects,
      PaymentsTableColumnsEffects,
      DashboardWidgetConfigEffects,
      HeadleaseDetailsEffects,
      EmailTemplateEffects,
      UserPreferencesEffects
    ]),
    !environment.production
      ? StoreDevtoolsModule.instrument({
        maxAge: 30,
        connectInZone: true
      })
      : [],
    AppRoutingModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the app is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerImmediately'
    }),
    CardModuleModule,
    CreditorDetailsModule
  ],
  providers: [
    ApplicationModeService,
    {provide: RouteReuseStrategy, useClass: MojoRouteReuseStrategy},
    {provide: ActionDispatcher, useExisting: DispatcherService},
    SystemConfigurationHttpService,
    EmailTemplateHttpService,
    EmailTemplateService,
    DocumentCentreConfigHttpService,
    SystemConfigurationService,
    ListerConfigurationHttpService,
    ListerConfigurationService,
    ManagerDetailsHttpService,
    ManagerDetailsService,
    DecimalPipe,
    CurrencyPipe,
    DatePipe,
    MapListPipe,
    ConfirmationService,
    {provide: Window, useValue: window},
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IdServerInterceptor,
      multi: true,
    },
    DashboardHomePageRouteGuard,
    ExternalUrlRouteGuard,
    DashboardModeOnlyGuard,
    {
      provide: "DashboardItemProvider",
      useClass: DashboardItemProviderService,
    },
    OutstandingDebtService,
    ClientParentService,
    DataFormatter,
    LeaseDetailsMapper,
    ClientDetailsMapper,
    UnitDetailsService,
    UnitDetailsMapper,
    LeaseDetailsHttpService,
    EstateDetailsService,
    EstateDetailsMapper,
    HeadleaseDetailsService,
    HeadLeaseDetailsMapper,
    SoftLabelsHttpService,
    ClientDetailsHttpService,
    UserSettingsHttpService,
    UserSettingsService,
    DiaryEventsHttpService,
    OverviewHttpService,
    OverviewService,
    AdminOverviewTileService,
    EntityRouteGuard,
    OverviewUrlService,
    PropertyDetailsHttpService,
    PropertyPictureService,
    PropertyDetailsMapper,
    PropertyPictureWidgetAdminHandler,
    GlobalStartupService,
    PasswordValidationService,
    AuthorisedBlobService,
    UrlBuilderService,
    ColumnFormatterService,
    RequestStoreService,
    HomepageSelectionHttpService,
    HomepageManagerService,
    FileHelperService,
    FilterService,
    MfsLimitedAccessConfigService,
    CsvDataService,
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    AuthService,
    TokenService,
    AuthGuardService,
    VersionService,
    OidcAuthService,
    OidcAuthRouteGuardService,
    ProductLicenseGuard,
    AddOnGuard,
    UserService,
    AboutHttpService,
    AboutService,
    RoleService,
    RoleGuardService,
    DashboardModeRoleGuardService,
    RoleHttpService,
    PmaPermissionsService,
    PmaPermissionsGuardService,
    TenancyScheduleTableHttpService,
    TenancyScheduleTableColumnsHttpService,
    ContactUsHttpService,
    UserDashboardHttpService,
    DashboardItemMapper,
    DashboardScrollService,
    GridsterConfigProviderService,
    DashboardService,
    MasterAdminDashboardItemProviderService,
    RouteContextService,
    CashBalanceHttpService,
    CashBalanceLabelService,
    CashBalanceGroupTypeProvider,
    WidgetConfigurationsService,
    ProfileHttpService,
    ProfileService,
    DefaultDashboardLayoutService,
    PreviewModeService,
    UserPermissionsService,
    DashboardWidgetFilterService,
    ListTypeUserDataFilterService,
    MojoUrlProvider,
    MojoSystemSettingsService,
    BrandProvider,
    BrandService,
    DashboardHelperService,
    MathematicalHelperService,
    CurrencyService,
    MyActivitiesTableHttpService,
    MyActivitiesDataHttpService,
    ContextToHttpParamsService,
    WidgetGalleryService,
    ClientParentDetailsService,
    ClientParentDetailsMapperService,
    TenantDetailsService,
    TenantDetailsHttpService,
    TenantDetailsMapperService,
    DebtorDetailsHttpService,
    DebtorDetailsService,
    DebtorDetailsMapperService,
    CurrentProductService,
    ProductRouteNavigator,
    UserProfilesHttpService,
    UserProfilesService,
    LandlordTableService,
    LandlordTableColumnService,
    LandlordTableHttpService,
    LandlordTableColumnsHttpService,
    LandlordDetailsHttpService,
    LandlordDetailsService,
    LandlordDetailsMapperService,
    SupplierDetailsService,
    SupplierDetailsHttpService,
    MfsSupplierDetailsService,
    MfsSupplierDetailsHttpService,
    SupplierOtherCreditorHttpService,
    DefaultAdminHandler,
    CreditorDetailsWidgetAdminHandler,
    CreditorDetailsService,
    CashBalancesWidgetAdminHandler,
    DefaultWidgetAdminHandlerProvider,
    CreditorAccountsHttpService,
    CreditorAccountService,
    InvoiceDocumentService,
    InvoiceUploadHttpService,
    PaymentsToYouService,
    PaymentsToYouHttpService,
    PaymentsToYouWidgetAdminHandler,
    PaymentsToYouToastService,
    InvoiceAndReceiptsService,
    {
      provide: PRODUCT_SERVICE_KEYS,
      useClass: MojoDashboardProductService,
      multi: true,
    },
    {provide: PRODUCT_SERVICE_KEYS, useClass: MciProductService, multi: true},
    {provide: PRODUCT_SERVICE_KEYS, useClass: MfsProductService, multi: true},
    {provide: PRODUCT_SERVICE_KEYS, useClass: MftProductService, multi: true},
    ProductSpecificServiceProvider,
    PmaEntityLookupHttpService,
    PmaEntityKeyHttpService,
    EntityKeyService,
    TenantParentService,
    TenantParentHttpService,
    SystemConfigurationHttpService,
    EmailTemplateHttpService,
    EmailTemplateService,
    DocumentCentreConfigHttpService,
    SystemConfigurationService,
    DebtBalancesDueFacadeService,
    provideHttpClient(withInterceptorsFromDi()),
    InvoiceStatusWidgetLineItemDataService,
    MfsAllowListHttpDataService,
    MfsAllowListDataService,
    MfsInvalidEntityRouteGuard,
    MftAllowListHttpDataService,
    MftAllowListDataService,
    MftInvalidEntityRouteGuard
  ]
})
export class AppModule {
}
